export const DchampsEventEnum = {
  DEV_CHAMPS_2023_09: 'DEV_CHAMPS_2023_09',
  DEV_CHAMPS_2023_10: 'DEV_CHAMPS_2023_10',
  DEV_CHAMPS_2023_11: 'DEV_CHAMPS_2023_11',
} as const;

export type DchampsEventType = keyof typeof DchampsEventEnum;

export const DchampsEventMothText = {
  [DchampsEventEnum.DEV_CHAMPS_2023_09]: 9,
  [DchampsEventEnum.DEV_CHAMPS_2023_10]: 10,
  [DchampsEventEnum.DEV_CHAMPS_2023_11]: 11,
};
